<template>
    <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
            <div class="row align-items-center">
                <div class="col">
                    <h3 class="page-title">Manage Dependent's Age</h3>
                </div>
                <div class="col-auto float-right ml-auto">
                    <button class="btn add-btn" @click="add">
                        <i class="fa fa-plus"></i>New Dependent's Age
                    </button>
                </div>
            </div>
        </div>
        <!-- /Page Header -->

        <!-- Filter -->
        <div class="row align-items-center mt-2">
            <div class="col-md-2 fit-content">Company</div>
            <div class="col-md-4 pl-md-0 fit-content">
                <select class="custom-select" v-model="company">
                    <option v-for="(item, i) in companies" :key="i" :value="item.CompanyName">
                        {{ item.CompanyName }}
                    </option>
                </select>
            </div>
        </div>
        <!-- /Filter -->

        <!-- Table List -->
        <div class="row mt-4">
            <div class="col-md-12">
                <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
                    <form id="saveForm" @submit.prevent="save"></form>
                    <table class="table table-bordered custom-table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th class="action-column">Action</th>
                                <th>Year</th>
                                <th>Dependent</th>
                                <th>Minimum Age</th>
                                <th>Maximum Age</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="showAddMode" class="table-info">
                                <td class="action-column">
                                    <button type="submit" class="btn" title="Save" form="saveForm">
                                        <i class="fa fa-save"></i>
                                    </button>
                                    <button type="button" class="btn" title="Cancel" @click="cancel">
                                        <i class="fa fa-window-close-o"></i>
                                    </button>
                                </td>
                                <td>
                                    <select class="custom-select" v-model="formData.year" form="saveForm" required>
                                        <option value="">-- Please Select --</option>
                                        <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                                    </select>
                                </td>
                                <td>
                                    <select class="custom-select" v-model="formData.dependent" form="saveForm" required>
                                        <option value="">-- Please Select --</option>
                                        <option value="Spouse">Spouse</option>
                                        <option value="Children">Children</option>
                                    </select>
                                </td>
                                <td>
                                    <input type="number" class="form-control" v-model="formData.minAge" step="1" min="0"
                                        form="saveForm" />
                                </td>
                                <td>
                                    <input type="number" class="form-control" v-model="formData.maxAge" step="1" min="0"
                                        form="saveForm" />
                                </td>
                            </tr>
                            <tr v-for="item in records" :key="item.Id">
                                <template v-if="formData.id !== item.Id">
                                    <td class="action-column">
                                        <button class="btn mt-2" title="Edit" @click="edit(item)">
                                            <i class="fa fa-edit"></i>
                                        </button>
                                        <button class="btn mt-2" title="Delete" @click="remove(item.Id)">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                    </td>
                                    <td>{{ item.Year }}</td>
                                    <td>{{ item.Dependent }}</td>
                                    <td>{{ item.MinAge }}</td>
                                    <td>{{ item.MaxAge }}</td>
                                </template>
                                <template v-else>
                                    <td class="action-column table-info">
                                        <button type="submit" class="btn" title="Save" form="saveForm">
                                            <i class="fa fa-save"></i>
                                        </button>
                                        <button type="button" class="btn" title="Cancel" @click="cancel">
                                            <i class="fa fa-window-close-o"></i>
                                        </button>
                                    </td>
                                    <td class="table-info">
                                        <select class="custom-select" v-model="formData.year" form="saveForm" required>
                                            <option value="">-- Please Select --</option>
                                            <option v-for="y in years" :key="y" :value="y">{{ y }}</option>
                                        </select>
                                    </td>
                                    <td class="table-info">
                                        <select class="custom-select" v-model="formData.dependent" form="saveForm"
                                            required>
                                            <option value="">-- Please Select --</option>
                                            <option value="Spouse">Spouse</option>
                                            <option value="Children">Children</option>
                                        </select>
                                    </td>
                                    <td class="table-info">
                                        <input type="number" class="form-control" v-model="formData.minAge" step="1"
                                            min="0" form="saveForm" />
                                    </td>
                                    <td class="table-info">
                                        <input type="number" class="form-control" v-model="formData.maxAge" step="1"
                                            min="0" form="saveForm" />
                                    </td>

                                </template>
                            </tr>
                            <tr v-if="records && !records.length">
                                <td colspan="5" class="text-center">{{ noRecordText }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- /Table List -->
    </div>
</template>

<script>
import API from "../../http-common.js";
import config from "../../config.js";
export default {
    data() {
        return {
            company: "",
            companies: [],
            records: null,
            showAddMode: false,
            noRecordText: config.NO_RECORD_TEXT,
            formData: {
                id: "",
                year: "",
                dependent: "",
                minAge: null,
                maxAge: null
            },
        }
    },
    computed: {
        token() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Token;
        },
        role() {
            let data = JSON.parse(localStorage.getItem("lambitoken"));
            return data.Role;
        },
        years() {
            let currentYear = new Date().getFullYear();
            let years = [];
            for (let i = currentYear - 1; i <= currentYear + 1; i++) {
                years.push(i);
            }
            return years;
        },
    },
    watch: {
        company(val) {
            this.resetForm();
            this.showAddMode = false;
            this.getSettings();
        },
    },
    methods: {
        getCompanies() {
            let param = {
                Token: this.token,
            };
            this.$store.state.isLoading = true;
            API.getCompanies(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.companies = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        getSettings() {
            let param = {
                Token: this.token,
                Company: this.company
            };
            this.$store.state.isLoading = true;
            API.getDependentAgeSetting(param)
                .then((response) => {
                    this.$store.state.isLoading = false;
                    if (response.data.success) {
                        this.records = response.data.record;
                    } else {
                        this.$swal(response.data.message, { icon: "error" });
                    }
                })
                .catch((error) => {
                    this.$store.state.isLoading = false;
                    this.$swal(error.response.data.Message, { icon: "error" });
                });
        },
        //action
        resetForm() {
            this.formData = {
                id: "",
                year: "",
                dependent: "",
                minAge: null,
                maxAge: null
            };
        },
        add() {
            this.showAddMode = true;
            this.resetForm();
        },
        edit(payload) {
            this.showAddMode = false;
            this.resetForm();
            this.formData.id = payload.Id;
            this.formData.year = payload.Year;
            this.formData.dependent = payload.Dependent;
            this.formData.minAge = payload.MinAge;
            this.formData.maxAge = payload.MaxAge;
        },
        cancel() {
            this.showAddMode = false;
            this.resetForm();
            this.getSettings();
        },
        remove(id) {
            let param = {
                Token: this.token,
                Id: id,
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to delete the record?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willDelete) => {
                if (willDelete) {
                    this.$store.state.isLoading = true;
                    API.deleteDependentAgeSetting(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.cancel();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            })
        },
        save() {
            //check max age must be greater than min age
            let maxAge = parseFloat(this.formData.maxAge);
            let minAge = parseFloat(this.formData.minAge);
            if (maxAge && minAge) {
                if (maxAge < minAge) {
                    this.$swal("Minimum Age cannot be greater than Maximum Age", { icon: "error" });
                    return;
                }
            }
            let param = {
                Token: this.token,
                Company: this.company,
                Id: this.formData.id,
                Year: this.formData.year,
                Dependent: this.formData.dependent,
                MinAge: this.formData.minAge,
                MaxAge: this.formData.maxAge
            };
            this.$swal({
                title: "Are you sure?",
                text: "Are you sure you want to save the record?",
                icon: "info",
                buttons: true,
                dangerMode: false,
            }).then((willSave) => {
                if (willSave) {
                    this.$store.state.isLoading = true;
                    API.saveDependentAgeSetting(param)
                        .then((response) => {
                            this.$store.state.isLoading = false;
                            this.$swal(response.data.message, {
                                icon: response.data.success ? "success" : "error",
                            });
                            if (response.data.success) {
                                this.cancel();
                            }
                        })
                        .catch((error) => {
                            this.$store.state.isLoading = false;
                            this.$swal(error.response.data.Message, { icon: "error" });
                        });
                }
            });
        }
    },
    mounted() {
        this.getCompanies();
        this.company = config.DEFAULT_COMPANY;
    },
    created() {
        if (this.role != "admin")
            this.$router.replace({ name: "home" });
    },
}
</script>

<style scoped>
.action-column {
    width: 5%;
}

.fit-content {
    max-width: fit-content;
}

.table {
    word-spacing: -3px;
}

select.custom-select {
    font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/Insurance/ManageDependentAge.vue